import React, { useState, useEffect } from 'react';
import '../ImagePrompt.css';
import './AvatarPreviewScreen.css'; // Cambio en el nombre del archivo CSS
import eyeSVG from '../Iconos/eye.svg';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const AvatarPreviewScreen: React.FC = () => { // Cambio en el nombre del componente
    const { t } = useTranslation();
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true); // Estado de carga
    const [progressMessage, setProgressMessage] = useState(''); // Mensaje de progreso
    const [generatedText, setGeneratedText] = useState('');
  
    useEffect(() => {
        const textDataJSON = localStorage.getItem('textData');
        if (textDataJSON) {
            const textData = JSON.parse(textDataJSON);
            setGeneratedText(textData.content);
        }
    }, []);
  
    useEffect(() => {
        const fetchVideoUrl = async () => {
            try {
                const sessionId = localStorage.getItem('sessionId'); // Asumiendo que el sessionId se guarda en el localStorage
                if (sessionId) {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto
  
                    console.log(backendUrl);
  
                    const response = await axios.get(`${backendUrl}/get-video-url`, {
                        params: { sessionId },
                    });
  
                    // Esperar 90 segundos para que el video se pueda servir como inline en AWS
                    setProgressMessage('Esperando que el video esté disponible...');
                    setTimeout(() => {
                        setVideoUrl(response.data.videoUrl); // Guardar la URL obtenida
                        setIsLoading(false); // Termina la carga
                    }, 60000); // 90 segundos
                } else {
                    console.error('No se encontró un sessionId en el localStorage');
                    setIsLoading(false); // Si no hay sessionId, detener la carga
                }
            } catch (error) {
                console.error('Error al obtener el URL del video:', error);
                setIsLoading(false); // Si hay un error, detener la carga
            }
        };
  
        fetchVideoUrl();
    }, []);
    useEffect(() => {
        const textDataJSON = localStorage.getItem('textData');
        if (textDataJSON) {
            const textData = JSON.parse(textDataJSON);
            setGeneratedText(textData.content);
        }
    }, []);

    useEffect(() => {
        const fetchVideoUrl = async () => {
            try {
                const sessionId = localStorage.getItem('sessionId'); // Asumiendo que el sessionId se guarda en el localStorage
                if (sessionId) {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

                    console.log(backendUrl);

                    const response = await axios.get(`${backendUrl}/get-video-url`, {
                        params: { sessionId },
                    });
                    setVideoUrl(response.data.videoUrl); // Guardar la URL obtenida
                } else {
                    console.error('No se encontró un sessionId en el localStorage');
                }
            } catch (error) {
                console.error('Error al obtener el URL del video:', error);
            }
        };

        fetchVideoUrl();
    }, []);

    return (
        <div>
            <div className="avatar-preview-header"> {/* Cambio en el nombre de la clase */}
                <img src={eyeSVG} alt="" /> <h2>{t('Preview')}:</h2>
            </div>
            <div className="avatar-preview-container">
                <div className="avatar-preview-content">
                    <div className="avatar-video-container">
                        {isLoading ? (
                            <div className="loading-container">
                                <p>{progressMessage || 'Cargando video...'}</p>
                                <div className="loading-bar"></div> {/* Barra de carga */}
                            </div>
                        ) : videoUrl ? (
                            <video src={videoUrl} controls className="avatar-video-element" />
                        ) : (
                            <p>No se pudo cargar el video.</p>
                        )}
                    </div>
                    {generatedText && (
                        <div className="avatar-preview-text">
                            <p>{generatedText}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AvatarPreviewScreen;
